import React from 'react';
import { Button, Typography } from '@material-ui/core';

import styles from './styles.scss';

const FourOhFour = () => (
  <div className={styles.fourOhFourWrapper}>
    <div className={styles.heading}>
      <Typography variant='h2'>404</Typography>
      <Typography variant='body1'>We couldn’t find the page you were looking for.</Typography>
    </div>
    <Button
      color='primary'
      fullWidth
      onClick={() => {
        window.history.back();
      }}
      type='button'
      variant='contained'
    >
      Go back
    </Button>
  </div>
);

export default FourOhFour;
